module.exports = __webpack_public_path__ + "img/home.7dffbe52.svg";